import { setupPhoneInput } from './phone';
import Form from './lead_form';
import { getDefaultLeadsFormData } from './default_leads_form_data';
import { submitLead } from './submit_lead';
import { handleClickChatUs } from './nav';
import { lockScroll, unlockScroll } from './lock_scroll';
import { sendLeadFormHeapEvents } from './form_analytics';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';

const NAV_CONTACT_DROPDOWN_OPEN_CLASS = 'contact-dropdown-open';

const nav = document.querySelector('.page-nav');
const contactUsOverlay = document.getElementById('contact-us-overlay');

let contactDropdownIsOpen = window.clientSideInjectionVars && window.clientSideInjectionVars.showContactUsOnLoad;
let iti;

contactDropdownIsOpen && openContactUsDropdown();

export function hookUpContactUs() {
  handleClickChatUs();
  const contactUsOpenButton = document.getElementById('nav-cta-contact-us');
  const contactUsCloseButton = document.getElementById('nav-cta-contact-us-close');

  if (!contactUsOpenButton) {
    return;
  }

  const form = document.getElementById('nav-cta-lead-form');
  const formInitial = document.getElementById('nav-cta-lead-initial');
  const formSuccess = document.getElementById('nav-cta-lead-success');

  async function onSubmit(event, values) {
    const { email, phone, companyName, company_size, fullName, product_interests } = values;
    const gdprVal = document.getElementById('gdpr-checkbox-contact').checked;
    let interestParams;

    if (product_interests === 'WORKSPACE') {
      interestParams = {
        product_interests: [product_interests],
        company_size
      };
    } else {
      interestParams = {
        product_interests: [product_interests]
      };
    }

    const notes = `${values.notes || ''}
Interest: ${product_interests}
Company Size: ${company_size}`;

    const paramsNotInForm = await getDefaultLeadsFormData('Global Contact CTA');
    await submitLead({
      email,
      phone,
      company_name: companyName,
      contact_name: fullName,
      ...interestParams,
      notes,
      ...paramsNotInForm,
      marketing_consent: gdprVal,
      submission_type: 'lead'
    });

    sendLeadFormHeapEvents(
      {
        email,
        phone,
        fullName,
        company_size
      },
      'Global Contact CTA'
    );

    hideElements(form, formInitial);
    showElements(formSuccess);
  }

  new Form(form, onSubmit);

  contactUsOpenButton.addEventListener('click', toggleContactUsDropdown, false);
  contactUsOpenButton.addEventListener('mousedown', preventFocus);

  contactUsCloseButton.addEventListener('click', toggleContactUsDropdown, false);
  contactUsCloseButton.addEventListener('mousedown', preventFocus);
}

function preventFocus(e) {
  e.preventDefault();
}

function openContactUsDropdown() {
  contactUsOverlay.classList.add('open');
  nav.classList.add(NAV_CONTACT_DROPDOWN_OPEN_CLASS);
  contactUsOverlay.setAttribute('aria-hidden', 'false');
  lockScroll();
  if (!iti) {
    iti = setupPhoneInput(document.getElementById('nav-cta-phone'));
  }
}

function closeContactUsDropdown() {
  contactUsOverlay.classList.remove('open');
  nav.classList.remove(NAV_CONTACT_DROPDOWN_OPEN_CLASS);
  contactUsOverlay.setAttribute('aria-hidden', 'true');
  unlockScroll();
}

function toggleContactUsDropdown() {
  if (!contactDropdownIsOpen) {
    openContactUsDropdown();
  } else {
    closeContactUsDropdown();
  }
  contactDropdownIsOpen = !contactDropdownIsOpen;
}
